// extracted by mini-css-extract-plugin
export var dropdownContainer = "_6j-5";
export var imageContainer = "_6j-4";
export var metricsGrid = "_6j-2";
export var productDetailContainer = "_6j-1";
export var productListContainer = "_6j-0";
export var subscriberTableContainer = "_6j-3";